export default __webpack_public_path__ + "static/media/ankle.0bb47b54.png";